import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import cuid from "cuid";
import Button from './Button';
import t from 'babel-plugin-yate/macro';
import Icon from './Icons';
import lendingTypes from '../config/lendingTypes';

const PageHeader = (props) => {
  const { title = "", breadcrumbsPages = [], actions, match, accessType } =  props;
  const lendingType = lendingTypes[match.params.lendingType] || '';

  const breadcrumbPath = [];
  const breadcrumbsPagesNumber = breadcrumbsPages.length;

  breadcrumbsPages.forEach((breadcrumb, index) =>
    breadcrumbsPagesNumber !== index + 1
      ? breadcrumbPath.push(breadcrumb, { title: " > " })
      : breadcrumbPath.push(breadcrumb)
  );

  return (
    <div className="flex mb-8">
      <div className="flex-grow">
        <h1 className="text-22 font-medium" style={{ lineHeight: "32px" }}>
          {title}
        </h1>

        {breadcrumbPath.length !== 0 && (
          <div
            className="text-14 text-grey-darkest"
            style={{ lineHeight: "22px" }}
          >
            {breadcrumbPath.map(({ route, title }, index) =>
              route ? (
                <span key={index}>
                  <Link to={route}>
                    <button className="text-blue-light">{title}</button>
                  </Link>
                </span>
              ) : (
                <span key={index}>{title}</span>
              )
            )}
          </div>
        )}
      </div>

      <div className="self-end ml-5">
        <div className="flex">
          {actions}

          {accessType?.some((type) => type === "broker_agent" || type === "admin") && (
            <Link
              to={`/${lendingType.urlPath}/generate/?${cuid()}`}
            >
              <Button
                title={t`New ${lendingType.shortName} request`}
                icon={true}
                color="blue"
                iconSrc={<Icon name="PlusCircle"/>}
                iconPosition="left"
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(PageHeader);
